import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { AmountWithCurrencySplit } from "@portal/BaseComponents/MultiCurrency/AmountWithCurrencySplit";
import { UnappliedPaymentsCredits } from "@portal/BaseComponents/MultiCurrency/UnappliedPaymentsAndCredits";
import { SnapShotTile } from "@portal/BaseComponents/SnapShotTile/SnapShotTile";
import { TileProps } from "../type";

function TotalOutstandingTile(props: TileProps) {
  const { loading, data } = props;

  const AmountComp = data ? (
    <Flex align="center" >
      <AmountWithCurrencySplit
        type="multi"
        amountWithCurrencySplit={data.outstanding_amount.outstanding_amount}
        showTooltip
        style={{
          fontSize: "var(--fluid-24-30)",
          fontWeight: "var(--fs-semibold)",
        }}
      />
      <UnappliedPaymentsCredits outstanding={data.outstanding_amount} />
    </Flex>
  ) : undefined;
  return (
    <HideWrapper hide={false}>
      <SnapShotTile
      space={'16'}
        heading={{ text: "Total Outstanding", fs: "16" }}
        loading={loading}
        count={{
          title: { value: "Open Invoices", fs: "12" },
          fs: "14",
          value:
            data?.outstanding_amount.open_invoices_balance_amount
              .invoice_count ?? 0,
        }}
        amount={AmountComp}
        size="lg"
      />
    </HideWrapper>
  );
}

export { TotalOutstandingTile };
